import Handlebars from "handlebars";
import { get as lodashGet } from "lodash";
import { registerHandleBarHelpers } from "shared/components/template/getStandardTemplateVariablesUtil";

export type RenderTemplateUtilProps = {
  template?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  templateData: any;
  timeZone?: string;
  templatePath?: string;
};

export const renderTemplateUtil = ({
  template,
  templateData,
  timeZone = "America/Chicago",
  templatePath,
}: RenderTemplateUtilProps): string => {
  try {
    registerHandleBarHelpers({ timeZone });

    const resolvedTemplate =
      templatePath && lodashGet(templateData, templatePath)
        ? lodashGet(templateData, templatePath)
        : template;

    const compiledTemplate = Handlebars.compile(resolvedTemplate, {
      noEscape: true,
    });
    return compiledTemplate(templateData);
  } catch (e: any) {
    const message =
      e?.message ??
      "Unknown error compiling template. Check template syntax or data shape.";
    return `Error compiling template <br><br><br>${message} <br> <br><br><textarea value="${template}"/>`;
  }
};
